var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav_w2" }, [
    _c(
      "div",
      { staticClass: "main" },
      _vm._l(_vm.navList, function (i, j) {
        return _c(
          "div",
          {
            key: j,
            staticClass: "item_2",
            class: { active: j == _vm.num },
            on: {
              click: function ($event) {
                return _vm.toSecond(i.url)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(i.specialClassName) + "\n    ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }